import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { HttpBaseService } from 'src/app/base/http-base.service';
import * as RolesActions from '../actions/roles.actions';
import { MessageService } from 'primeng/api';
import { rolesTable } from 'src/app/STORE/selectors/roles.selector';
import { TranslateService } from '@ngx-translate/core';
@Injectable()
export class RoleEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);
  private messageService = inject(MessageService);
  private translate = inject(TranslateService);

  oldRecords = [];
  //   Get Roles Data
  getRolesItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RolesActions.getRoles),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.filter).subscribe(
            (rolesTables: any) => {
              if (rolesTables) {
                this.store.dispatch(
                  RolesActions.setRoles({ rolesTable: rolesTables.results, totalRecords: rolesTables.total })
                );
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getRolesItemsWithSorting$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RolesActions.getRolesWithSorting),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.filter).subscribe(
            (rolesTables: any) => {
              if (action?.orgChange) {
                if (rolesTables) {
                  this.store.dispatch(
                    RolesActions.setRoles({ rolesTable: rolesTables.results, totalRecords: rolesTables.total })
                  );
                }
              } else {
                this.store.select(rolesTable).subscribe((data: any) => {
                  // console.log(organizationData.results)
                  // console.log(data.organizationData)
                  const oldrolesTable = data.rolesTable;
                  if (oldrolesTable !== undefined && oldrolesTable !== null) {
                    this.oldRecords = oldrolesTable;
                  }
                });
                if (rolesTables) {
                  const updateRecords = [...this.oldRecords, ...rolesTables.results];
                  // console.log(updateRecords)
                  const ids = updateRecords.map((o) => o.sid);
                  const filtered = updateRecords.filter(({ sid }, index) => !ids.includes(sid, index + 1));
                  // console.log(filtered)

                  this.store.dispatch(RolesActions.setRoles({ rolesTable: filtered, totalRecords: rolesTables.total }));
                }
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getSidBasedRoles$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RolesActions.getSidBasedRoles),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + action.sid;
          return this.baseService[apiConstants?.method](apiConstants).subscribe((sidRoleData: any) => {
            this.store.dispatch(
              RolesActions.setSidBasedRoles({
                sidRoleData: { ...sidRoleData }
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );
  srcText: string | null = null;
  // Get Role Data Search
  getRolesBasedOnSearch$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RolesActions.getRolesBasedOnSearch),
        map((action: any) => {
          const searchQuery = {
            start: 0,
            length: 100,
            search: action.searchFields
          };
          return this.baseService[action.apiConstants?.method](
            action.apiConstants,
            JSON.stringify(searchQuery)
          ).subscribe((_rolesTable: any) => {
            this.srcText = '';
            this.store.dispatch(
              RolesActions.setRoles({
                rolesTable: _rolesTable.results,
                totalRecords: _rolesTable.total
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );

  //   Save Roles Data
  saveRolesItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RolesActions.sentRoles),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.saveRolesData).subscribe(
            (response: any) => {
              if (action.apiConstants.method === 'put') {
                this.showMessage('success', this.translate.instant('ROLE_UPDATED_SUCCESSFULLY'));
              } else if (action.apiConstants.method === 'post') {
                this.showMessage('success', 'Role Created Successfully');
              }
              this.store.dispatch(RolesActions.updateRoles({ updateRolesData: response }));
            },
            (err) => {
              console.log('error');
              console.log(err);
              this.store.dispatch(
                RolesActions.getErrorMessage({
                  errorMessage: err
                })
              );
              if (err.error.ERROR_CODE === 'ALREADY_EXISTS') {
                this.showMessage('error', this.translate.instant('ROLE_ALREADY_EXISTS'));
              }
              if (err.error.ERROR_CODE === 'ALREADY_EXISTS_IN_DATA_MODEL') {
                this.showMessage('error', this.translate.instant('FIELD_ALREADY_EXISTS_IN_APPLICATION_USER'));
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
  // Delete Roles Data
  setRolesToDeleteItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RolesActions.sentDeleteRoles),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + action.rolesId;
          return this.baseService[action.apiConstants?.method](apiConstants).subscribe(
            (menuData: any) => {
              if (menuData.NotDeleted && menuData.NotDeleted.length === 1) {
                this.showMessage(
                  'error',
                  `Role ${menuData.NotDeleted[0].name} ${this.translate.instant('ROLE_HAS_REFERENCE')}`
                );
                return this.store.dispatch(
                  RolesActions.setRolesToDelete({
                    rolesWithRefAndDeleted: action.rolesId,
                    filterRoles: false
                  })
                );
              } else if (menuData.NotDeleted && menuData.NotDeleted.length > 1) {
                const roleNames = menuData.NotDeleted.map((role) => role.name).join(', ');
                this.showMessage('error', `Roles ${roleNames} ${this.translate.instant('ROLES_HAVE_REFERENCE')}`);
                return this.store.dispatch(
                  RolesActions.setRolesToDelete({
                    rolesWithRefAndDeleted: action.rolesId,
                    filterRoles: false
                  })
                );
              }
              this.showMessage('success', 'Role Deleted Successfully');
              return this.store.dispatch(
                RolesActions.setRolesToDelete({
                  rolesWithRefAndDeleted: action.rolesId,
                  filterRoles: true
                })
              );
            },
            (error) => {
              this.showMessage(
                'error',
                `An error occurred while attempting to delete the role ${action.roleName}. Please try again later. If the issue persists, kindly contact our support team for assistance`
              );
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  // Get All Roles By App Id
  getAllRolesByAppId$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RolesActions.getAllRolesByAppId),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants).subscribe((rolesData: any) => {
            if (rolesData && Array.isArray(rolesData)) {
              // Sort roles by name property
              const sortedRoles = rolesData.sort((a, b) => {
                const nameA = (a.name || '').toLowerCase();
                const nameB = (b.name || '').toLowerCase();
                return nameA.localeCompare(nameB, 'en', { sensitivity: 'base' });
              });
              this.store.dispatch(
                RolesActions.setAllRolesSortedByName({
                  sortedRolesByName: sortedRoles
                })
              );
            }
          });
        })
      ),
    {
      dispatch: false
    }
  );

  showMessage(status: string, message: string, detail?: string) {
    this.messageService.clear();
    this.messageService.add({
      life: 10000,
      severity: status,
      summary: message,
      detail: detail
    });
  }
}
